import { render, staticRenderFns } from "./ApplyFaq.vue?vue&type=template&id=0c1dfd40&scoped=true&"
import script from "./ApplyFaq.vue?vue&type=script&lang=js&"
export * from "./ApplyFaq.vue?vue&type=script&lang=js&"
import style0 from "./ApplyFaq.vue?vue&type=style&index=0&id=0c1dfd40&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1dfd40",
  null
  
)

export default component.exports